import React, { useState, useRef, useEffect } from 'react';
// import ColumnSelector from '../data-table-columns/ColumnSelector';
import { InstallationOption, fetchInstallationsForDropdown } from '../../dispatchers/WellTestDispatcher';
import { useAppDispatch, useAppSelector } from '../../hooks/storeHooks';
import CustomDropdown from '../common/CustomDropdown';
import ColumnSelector from '../column-selector/colum-selector';
import useConfig from '../../hooks/useConfig';
import { ProtectAction } from '../../rbac';
import Tooltip from '../../features/common/tooltip/ToolTip';
// import { GlobalFilter } from './DataTable';

interface TableToolbarProps {
  ref: any;
  columns: { id: string; Header: string | React.ReactNode; isVisible: boolean }[];
  onColumnToggle: (columnId: string) => void;
  onSaveColumns: () => void;
  onSearch: (searchTerm: string) => void;
  onUpdateColumns: (updated: { id: string; Header: string; isVisible: boolean }[]) => void;
  onApplyClicked: (configUpdates?: any, columns?: any, saveConfig?: boolean) => void;
  saveConfigHasbeenClicked: (config: boolean) => void;
  resetToDefaultSystemClicked?: () => void;
  disableAllInstallations?: boolean;
  hideAllInstallations?: boolean;
  disableColumns?: boolean;
  onExportXLS: () => void;
  onInstallationSelect?: (installNumber: number | null) => void;
  tableName?: string;
  isResetClicked?: boolean;
  isTaskTableInitialized?: boolean;
  assetId?: string;
  wellTestTable?: boolean;
  isActionsButtonVisible?: boolean;
  disableActions?: boolean;
  onActionsClick?: () => void;
  rightToolbarContent?: React.ReactNode;
  isColumnsVisible?: boolean;
  isActionsDropdownOpen?: boolean;
  rPermission: { [key: string]: boolean };
}

const TableToolbar: React.FC<TableToolbarProps> = React.forwardRef<HTMLDivElement, TableToolbarProps>((props, ref) => {
  const {
    columns,
    onSearch,
    onUpdateColumns,
    onExportXLS,
    onApplyClicked,
    saveConfigHasbeenClicked,
    resetToDefaultSystemClicked,
    disableAllInstallations,
    hideAllInstallations,
    disableColumns,
    onInstallationSelect,
    tableName,
    isResetClicked,
    wellTestTable,
    isActionsButtonVisible = false,
    onActionsClick,
    disableActions = false,
    rightToolbarContent,
    isColumnsVisible = true,
    isActionsDropdownOpen = false,
    rPermission,
  } = props;

  const dispatch = useAppDispatch();
  const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isExportDropdownOpen, setIsExportDropdownOpen] = useState(false);
  const exportDropdownRef = useRef<HTMLDivElement>(null);
  const wellTestId = useAppSelector((state: any) => state.WellTestIdSlice?.data?.WellId);
  const { enablePumpChecker } = useConfig();
  const installationOptions = useAppSelector((state: any) => state.WellTestInstallationsSlice?.data);
  const isGLWell = installationOptions?.[0]?.MethodOfProduction?.toUpperCase() === 'GL';

  const filteredInstallations = enablePumpChecker
    ? installationOptions?.filter((opt: InstallationOption) =>
      isGLWell ? opt.MethodOfProduction?.toUpperCase() === 'GL' : opt.MethodOfProduction?.toUpperCase() === 'ESP',
    ) || []
    : [];

  const [isInstallationsDropdownOpen, setIsInstallationsDropdownOpen] = useState(false);
  const [selectedInstallation, setSelectedInstallation] = useState<string>('All installations');
  const pumpCheckerPageData = useAppSelector((state: any) => state.testWellColumnsSlice.data?.widgets);

  useEffect(() => {
    if (ref && 'current' in ref && ref.current) {
      ref.current.innerHTML = '<div></div>'; // Example usage of ref
    }
  }, [ref]);

  useEffect(() => {
    setSelectedInstallation('All installations');
    onInstallationSelect?.(null);
  }, [installationOptions]);

  useEffect(() => {
    if (ref && 'current' in ref && ref.current) {
      const handleClickOutside = (event: MouseEvent) => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          ref.current.onchange = () => {
            console.log('Change event triggered after clicking outside');
          };
        }
      };

      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }

    return undefined; // Explicitly return undefined for all code paths
  }, [ref]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value.trim());
  };
  const [localColumns, setLocalColumns] = useState(() =>
    columns.map((col) => ({
      id: col.id,
      Header: typeof col.Header === 'string' ? col.Header : '',
      isVisible: col.isVisible,
      key: col.id,
    })),
  );

  const [hasReset, setHasReset] = useState(false);
  const [hasColumnsReset, setHasColumnsReset] = useState(false);

  useEffect(() => {
    if (hasReset || !localColumns.length || hasColumnsReset) {
      setLocalColumns(
        columns.map((col) => ({
          id: col.id,
          Header: typeof col.Header === 'string' ? col.Header : '',
          isVisible: col.isVisible,
          key: col.id,
        })),
      );
      setHasReset(false);
      setHasColumnsReset(false);
    }
  }, [hasReset, columns, isResetClicked, hasColumnsReset]);

  useEffect(() => {
    setHasColumnsReset(true);
  }, [pumpCheckerPageData]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (exportDropdownRef.current && !exportDropdownRef.current.contains(event.target as Node)) {
        setIsExportDropdownOpen(false);
      }
    };

    if (isExportDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isExportDropdownOpen]);

  const handleExportXLS = () => {
    onExportXLS();
    setIsExportDropdownOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const panelElement = document.querySelector('.main-container-panel');
      if (panelElement && !panelElement.contains(event.target as Node)) {
        setIsColumnSelectorOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setIsColumnSelectorOpen]);

  useEffect(() => {
    if (!disableAllInstallations && wellTestId) {
      dispatch(fetchInstallationsForDropdown(wellTestId));
    }
  }, [disableAllInstallations, wellTestId]);

  useEffect(() => {
    if ((Array.isArray(installationOptions) && installationOptions.length === 0) || !installationOptions) {
      handleInstallationSelect('All installations');
    }
  }, [installationOptions]);

  const handleInstallationSelect = (selectedDescription: string) => {
    setSelectedInstallation(selectedDescription);
    if (selectedDescription === 'All installations') {
      onInstallationSelect?.(null); // Pass null for "All installations"
      return;
    }

    const selectedInstallation = installationOptions.find(
      (opt: { Description: string }) => opt.Description === selectedDescription,
    );

    if (selectedInstallation) {
      onInstallationSelect?.(selectedInstallation.InstallNumber);
    }
  };

  const clearSearch = () => {
    setSearchTerm('');
    onSearch('');
  };
  const actionsDropdownRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <section className='flex flex-row w-full justify-between flex-nowrap relative my-[12px] px-[24px]'>
        <div className='basis-2/3 flex flex-row gap-[8px]'>
          {isColumnsVisible && !disableColumns && (
            <ProtectAction canAccess={rPermission.canConfigureColumns}>
              <button
                analytics-id='table-toolbar-columns-btn'
                className={`flex w-[118px] h-[40px] pt-[10px] pr-[16px] pb-[10px] pl-[16px] gap-[8px] justify-center items-center shrink-0 flex-nowrap bg-[#131f2e] rounded-[8px] border-solid border border-[#4a5463] relative overflow-hidden shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] table-button ${!enablePumpChecker && !wellTestTable ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => setIsColumnSelectorOpen(true)}
                disabled={!enablePumpChecker && !wellTestTable}
              >
                <span className='ico-colom' />
                <span className="h-[20px] shrink-0 basis-auto font-['Mulish'] text-[14px] leading-[20px] text-[#f7f9f9] relative text-left whitespace-nowrap">
                  Columns
                </span>
              </button>
            </ProtectAction>
          )}
          <div className='relative' ref={exportDropdownRef}>
            <ProtectAction
              canAccess={
                (tableName == 'Time Data' && rPermission.canExportData) ||
                (tableName == 'Daily average' && rPermission.canExportDailyAverage) ||
                ((tableName == 'Well Test' || tableName == 'Real-Time-well-Test') && rPermission.canExport) ||
                (tableName == 'taskDetails' && rPermission.canExport) ||
                (tableName == 'wellNotes' && rPermission.canExport) ||
                rPermission.unProtected
              }
            >
              <button
                analytics-id='table-toolbar-export-btn'
                className={`flex w-[133px] h-[40px] pt-[10px] pr-[16px] pb-[10px] pl-[16px] gap-[8px] items-center shrink-0 flex-nowrap bg-[#131f2e] rounded-[8px] border-solid border border-[#4a5463] relative overflow-hidden shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] table-button ${isActionsButtonVisible ? 'custom-view-toolbar-button' : ''}`}
                onClick={() => setIsExportDropdownOpen(!isExportDropdownOpen)}
              >
                <span className='ico-down' />
                <span className="h-[20px] shrink-0 basis-auto font-['Mulish'] text-[14px] leading-[20px] text-[#f7f9f9] relative text-left whitespace-nowrap">
                  Export
                </span>
                <span className={`down-chevron ${isExportDropdownOpen ? 'open' : ''}`} />
              </button>
            </ProtectAction>

            {isExportDropdownOpen && (
              <div
                className='absolute top-full left-0 mt-[2px] w-[160px] bg-[#131f2e] border border-[#4a5463] rounded-[8px] shadow-lg'
                style={{ zIndex: 999999, top: '40px', width: '132px' }}
              >
                <ul>
                  <li
                    className='px-4 py-3 text-[#f7f9f9] hover:bg-[#1c2a3b] cursor-pointer flex items-center gap-2'
                    onClick={() => {
                      handleExportXLS();
                    }}
                  >
                    <span className="font-['Mulish'] text-[14px]">Export XLS</span>
                  </li>
                </ul>
              </div>
            )}
          </div>
          {isActionsButtonVisible && (
            <div className='relative' ref={actionsDropdownRef}>
              <Tooltip
                content={
                  disableActions ? 'Previous scan must be complete to perform new actions.' : 'Perform well actions'
                }
                direction='top'
              >
                <button
                  analytics-id='table-toolbar-columns-btn'
                  className={`flex w-[133px] h-[40px] pt-[10px] pr-[16px] pb-[10px] pl-[16px] gap-[8px] justify-center items-center shrink-0 flex-nowrap bg-[#131f2e] rounded-[8px] border-solid border border-[#4a5463] relative overflow-hidden shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] table-button ${disableActions ? 'opacity-50 cursor-not-allowed' : ''} custom-view-toolbar-button`}
                  disabled={disableActions}
                  onClick={() => {
                    if (onActionsClick) onActionsClick();
                  }}
                >
                  <span className='ico-lightening' />
                  <span className="h-[20px] shrink-0 basis-auto font-['Mulish'] text-[14px] leading-[20px] text-[#f7f9f9] relative text-left whitespace-nowrap">
                    Actions
                  </span>
                  <span className={`down-chevron ${isActionsDropdownOpen ? 'open' : ''}`} />
                </button>
              </Tooltip>
            </div>
          )}
        </div>
        <div className='basis-1/3 flex flex-row gap-[8px] justify-end'>
          <div className='flex w-full md:w-[290px] h-[40px] flex-col gap-[6px] items-start shrink-0 flex-nowrap relative'>
            {ref ? (
              <div
                ref={ref} // Assigning the forwarded ref
                className='flex flex-col gap-[6px] items-start self-stretch shrink-0 flex-nowrap relative w-full'
              ></div>
            ) : (
              <div className='flex flex-col gap-[6px] items-start self-stretch shrink-0 flex-nowrap relative w-full'>
                <div className='flex items-center w-full bg-[#001023] rounded-[8px] border border-solid border-[#4a5463] relative shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] px-[12px] py-[6px]'>
                  <span className='ico-search' />
                  <input
                    type='text'
                    placeholder='Search'
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{ border: 'none', background: 'transparent', outline: 'none' }}
                    className="flex-1 h-[24px] ml-[8px] font-['Mulish'] text-[14px] font-normal leading-[24px] text-[#b8c5cc] bg-transparent border-none"
                  />
                  {searchTerm && (
                    <button
                      className='ml-[8px] text-[#b8c5cc] hover:text-white text-[16px] leading-none p-0 m-0 bg-transparent border-none cursor-pointer flex items-center justify-center'
                      onClick={clearSearch}
                      type='button'
                      aria-label='Clear search'
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
          {rightToolbarContent}
          {!disableAllInstallations && Array.isArray(installationOptions) && !hideAllInstallations && (
            <div>
              <button
                analytics-id='table-toolbar-installations-btn'
                className='flex h-[40px] pt-[8px] pr-[14px] pb-[8px] pl-[14px] gap-[8px] justify-center items-center shrink-0 flex-nowrap bg-[#131f2e] rounded-[8px] border border-[#4a5463] shadow table-button'
                onClick={() => setIsInstallationsDropdownOpen((prev) => !prev)}
              >
                <span className='h-[20px] w-[335px] text-[14px] text-left whitespace-nowrap'>
                  {selectedInstallation}
                </span>
                <span className={`down-chevron ${isInstallationsDropdownOpen ? 'open' : ''}`} />
              </button>
              <span className='toolbar-installation-dropdown'>
                <CustomDropdown
                  isOpen={isInstallationsDropdownOpen}
                  onClose={() => setIsInstallationsDropdownOpen(false)}
                  options={[
                    'All installations',
                    ...filteredInstallations.map((opt: InstallationOption) => opt.Description),
                  ]}
                  onClick={handleInstallationSelect}
                />
              </span>
            </div>
          )}
        </div>
      </section>

      {/* Column Selector Fly-out Panel */}
      {isColumnSelectorOpen && (
        <ColumnSelector
          columnsData={localColumns}
          onUpdateColumns={(updated) => {
            setLocalColumns(updated);
            onUpdateColumns(updated);
          }}
          onClose={() => setIsColumnSelectorOpen(false)}
          onApplyClickedInColumn={onApplyClicked}
          saveConfigHasbeenClicked={saveConfigHasbeenClicked}
          resetToDefaultSystemClicked={() => {
            resetToDefaultSystemClicked?.();
            setHasReset(true);
          }}
          tableName={tableName}
          isChartConfig={false}
        />
      )}
    </>
  );
});

export default TableToolbar;
